import React, { useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { Environments } from "@emisgroup/cohort-builder-kit";
import { IRootState } from "../../../../reducer/CombineReducer";
import { BandsTypes } from "../Banding/Types";
import { FetchOutputConfigList, updateOutputConfig } from "../OutputConfigLandingPage/OutputConfigList/Script";
import { OutputConfigSlice } from "../redux";
import { SelectedConfigType } from "../redux/Types";
import { useUser } from "../../../../AuthContext";
import { OutputConfigDialogView } from "./OutputConfigDialog.view";

interface OutputConfigDialogProps {
  /**
   * Flag to show the dialog
   */
  show: boolean;
}

export interface outputHeaderType {
  /**
   * Key for the title
   */
  key: string;
  /**
   * Value for the Titles
   */
  value: string;
}

/**
 * Responsible for Output config dialog logic
 * @returns Output config dialog logic
 */
export const OutputConfigDialog: React.FC<OutputConfigDialogProps> = (props: OutputConfigDialogProps) => {
  const { show } = props;
  const dispatch = useDispatch();
  const [
    extractState,
    outputConfig,
    notificationState
  ] = useSelector((state: IRootState) => [
    state.extractState,
    state.outputConfig,
    state.notificationState
  ], shallowEqual);
  const [isSaveButtonClick, setIsSaveButtonClick] = useState(false);
  const selectedTab = outputConfig.selectedTab;
  const selectedExtract = extractState.selectedExtract;
  const extractGuid = selectedExtract?.extractGuid as string;
  const extractName = selectedExtract?.extractName;
  const [menu, setMenu] = useState(selectedTab);
  const [editConfigName, setEditConfigName] = useState("");
  const { user } = useUser();
  const env = process.env.APP_TARGET_ENV as Environments;
  const selectedBandingType = outputConfig.selectedBandingDetails.bandType;
  const updatedEditConfigName = outputConfig.editConfig.configName;
  const selectedConfigName = outputConfig.selectedOutputConfig.name;
  const headerName = [
    {
      "key": "Extract: ",
      "value": extractName
    },
    {
      "key": "Config: ",
      "value": selectedConfigName
    },
  ];
  const title = !show ? "OutputConfig.CreateDialog.Title" : headerName as unknown as outputHeaderType[];
  const className = !show ? "ebt-extract__output-config-dialog" : "ebt-extract__output-config-dialog-full";
  const { t: translate } = useTranslation();

  const isValid = Boolean(updatedEditConfigName && selectedConfigName);

  useEffect(() => {
    if (updatedEditConfigName) {
      setEditConfigName(updatedEditConfigName);
    } else {
      setEditConfigName(selectedConfigName);
    }
  }, [updatedEditConfigName]);

  useEffect(() => {
    setMenu(selectedTab);
  }, [selectedTab]);

  /**
   * Toggle dialog show
   */
  const onCloseDialog = (): void => {
    dispatch(OutputConfigSlice.actions.setSelectedConfig({} as SelectedConfigType));
    FetchOutputConfigList(dispatch, translate, extractGuid, env, user?.token);
    dispatch(OutputConfigSlice.actions.setFinalOutputList([]));
  };

  /**
   * Handler to update the config
   */
  const handleOnSave = (): void => {
    setIsSaveButtonClick(true);
    updateOutputConfig(
      dispatch,
      translate,
      outputConfig.selectedOutputConfig.id,
      editConfigName,
      env,
      user?.token
    );
  };

  return (
    <>
      <OutputConfigDialogView
        onCloseDialog={onCloseDialog}
        isToShow={show}
        title={title}
        className={className}
        menu={menu}
        bandType={selectedBandingType as BandsTypes}
        onSave={handleOnSave}
        disabled={isValid}
        notificationItems={notificationState.notificationItems}
        isSaveButtonClick={isSaveButtonClick}
      />
    </>
  );
};
